/* eslint-disable no-nested-ternary */
import React, { useContext } from "react";
import { object, arrayOf } from "prop-types";
import { PageContext } from "../../PageContext";
import { CardsContainerGrid } from "../../CardsContainer";
import { HotelCardTopResults } from "../../Card";
import { RCL as useTranslation } from "../../RCL";
import utils from "../../../utils/gatsby-helpers";

const HotelTilesConnector = ({ hotels }) => {
	const exploreMoreLabel = useTranslation({ searchKey: "explore-more" });
	const pageContext = useContext(PageContext);
	const loadAllLabel = useTranslation({ searchKey: "load-all" });
	const loadMoreLabel = useTranslation({ searchKey: "load-more" });

	return (
		<CardsContainerGrid
			numberToShow={6}
			moreToShow={6}
			labels={{
				loadAll: loadAllLabel,
				loadMore: loadMoreLabel,
			}}>
			{hotels?.map(hotel => {
				const hotelData = hotel.data;
				const destinationName = hotelData.DestinationName;
				const countryName = hotelData.RegionName;

				return (
					<HotelCardTopResults
						id={hotelData.HotelCode}
						key={hotelData.HotelCode}
						header={hotelData.HotelName}
						subheader={
							destinationName
								? countryName
									? `${destinationName}, ${countryName}`
									: destinationName
								: countryName
						}
						image={{
							alt: hotelData.HotelName,
							src: hotelData.HotelImages?.images?.[0]?.src,
						}}
						stars={parseFloat(hotelData.StarRating)}
						minAge={parseInt(hotelData.Adults?.[0]?.MinimumGuestAge || 0, 10)}
						link={{
							to:
								hotelData.HotelName &&
								utils.getHotelURL(
									pageContext?.locale?.slice(0, 2),
									countryName,
									destinationName,
									hotelData.HotelName
								),
							text: exploreMoreLabel,
							target: "_self",
						}}
					/>
				);
			})}
		</CardsContainerGrid>
	);
};

HotelTilesConnector.propTypes = {
	hotels: arrayOf(object),
};

HotelTilesConnector.defaultProps = {
	hotels: [],
};

export default HotelTilesConnector;
export { HotelTilesConnector };
